/* global $, query_string, data */
/* eslint-disable no-use-before-define, no-plusplus */
import * as d3 from 'd3'
import _ from 'underscore'
import table from 'bam-node-savant-table/table'
import { colorScaleNumbers } from 'bam-node-baseball-savant/utils/scales'

let ticking = false
let isFixedHeaderShowing = false
const tableDivId = 'sprint_speed'

$(document).ready(() => {
    const $typeSelect = document.getElementById('ddlType')

    $typeSelect.addEventListener('change', (e) => {
        document.getElementById('lblType').innerText = `Type: ${e.target.value}`
    })

    $('#ddlTeamId').change(() => {
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    })
    $('#ddlPosition').change(() => {
        $('#lblPosition').html($('#ddlPosition option:selected').text())
    })

    document
        .getElementById('ddlStartSeason')
        .addEventListener('change', (e) => {
            document.getElementById(
                'lblStartSeason'
            ).innerText = `Start Year: ${e.target.value}`
        })

    document.getElementById('ddlEndSeason').addEventListener('change', (e) => {
        document.getElementById(
            'lblEndSeason'
        ).innerText = `End Year: ${e.target.value}`
    })

    $('#ddlMin').change(() => {
        $('#lblMin').html(`Minimum Opportunities (${$('#ddlMin').val()})`)
    })

    if (query_string.min) {
        $('#ddlMin').val(query_string.min).attr('selected', true)
        $('#lblMin').html(`Minimum Opportunities (${$('#ddlMin').val()})`)
    }

    // Respect old links to move to range
    if (
        query_string.year &&
        !query_string.max_season &&
        !query_string.min_season
    ) {
        query_string.max_season = query_string.year
        query_string.min_season = query_string.year
    }

    if (query_string.min_season) {
        // Set min year select
        document.getElementById('ddlStartSeason').value =
            query_string.min_season
        document.getElementById(
            'lblStartSeason'
        ).innerText = `Start year: ${query_string.min_season}`
    }
    if (query_string.max_season) {
        // Set max year select
        document.getElementById('ddlEndSeason').value = query_string.max_season
        document.getElementById(
            'lblEndSeason'
        ).innerText = `End year: ${query_string.max_season}`
    }

    if (query_string.team) {
        $('#ddlTeamId').val(query_string.team).attr('selected', true)
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    }

    if (query_string.position) {
        $('#ddlPosition').val(query_string.position).attr('selected', true)
        $('#lblPosition').html($('#ddlPosition option:selected').text())
    }

    if (query_string.sortDir) {
        $('#sortDir').val(query_string.sortDir)
    }

    if (query_string.sort) {
        $('#sort').val(query_string.sort)
    }

    $('form').submit(false)

    if (data && data.length > 0) {
        let dataLoad = data
        if (query_string.team) {
            dataLoad = _.filter(
                dataLoad,
                (d) => d.team_id === Number(query_string.team)
            )
        }

        const headers = [
            {
                name: 'Player',
                field: 'href',
                customSortField: 'name_display_last_first',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                photoId: 'runner_id',
            },
            {
                name: 'Team',
                field: 'name_abbrev',
                headerClass: 'th-component-header align-left',
                fieldClass: 'tr-data sprint-speed-team-size align-left',
                photo: '<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" />',
                photoId: 'team_id',
                photoOnly: false,
            },
            {
                name: 'Position',
                field: 'position_name',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: 'Competitive Runs',
                field: 'n',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: 'Bolts',
                field: 'n_bolts',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: 'HP to 1B',
                field: 'hp_to_1b',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },

            {
                name: 'Sprint Speed (ft / sec)',
                field: 'r_sprint_speed_top50percent_pretty',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data sprint-speed-size',
                highlight: [21, 27, 32],
            },
        ]

        if (query_string.max_season === query_string.min_season) {
            const age = {
                name: 'Age',
                field: 'age',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            }
            headers.splice(2, 0, age)
        }

        const width = $(`#${tableDivId}`).outerWidth()
        let repeatHeaders = false
        if (width <= 768) {
            repeatHeaders = 15
        }

        // eslint-disable-next-line no-new, new-cap
        new table({
            id: 'sprint_speed',
            repeatHeader: repeatHeaders,
            headers,
            data: dataLoad,
            defaultSort:
                headers[Number($('#sort').val())].customSortField ||
                headers[Number($('#sort').val())].field,
            defaultSortDirection: $('#sortDir').val(),
            sortClass: 'column-sort',
            showRank: true,
        })
    } else {
        $('#NoData').html('<h1>No Data Found.</h2>')
    }
    function getTeamUrl() {
        const season = document.getElementById('ddlStartSeason').value
        const team = document.getElementById('ddlTeamId').value
        return `/leaderboard/sprint-speed-team?season=${season}&team=${team}`
    }

    function getUrl() {
        const minSeason = document.getElementById('ddlStartSeason').value
        const maxSeason = document.getElementById('ddlEndSeason').value
        const position = document.getElementById('ddlPosition').value
        const team = document.getElementById('ddlTeamId').value
        const min = document.getElementById('ddlMin').value
        return `/leaderboard/sprint_speed?min_season=${minSeason}&max_season=${maxSeason}&position=${position}&team=${team}&min=${min}`
    }

    $('#btnUpdate').click(() => {
        if ($typeSelect.value === 'player') {
            window.location.href = getUrl()
        } else {
            window.location.href = getTeamUrl()
        }
    })
    $('#btnCSV').click(() => {
        window.location.href = `${getUrl()}&csv=true`
    })

    $(document).on(
        'click',
        'th.th-component-header',
        function handleHeaderClick() {
            const id = this.id.split('-')[1]

            if (Number($('#sort').val()) === Number(id)) {
                if ($('#sortDir').val() === 'desc') {
                    $('#sortDir').val('asc')
                } else {
                    $('#sortDir').val('desc')
                }
            } else {
                $('#sortDir').val('desc')
            }
            $('#sort').val(id)
            isFixedHeaderShowing = false
            checkHeaderPosition(tableDivId)
            populateUrl()
        }
    )

    window.addEventListener('scroll', () => {
        if (!ticking && data.length) {
            window.requestAnimationFrame(() => {
                checkHeaderPosition(tableDivId)
                ticking = false
            })

            ticking = true
        }
    })

    function checkHeaderPosition(divId) {
        const scrollPosY = window.scrollY
        const posTop = $(`#${divId}`).offset().top
        const height = $(`#${divId} table thead`).height()
        if (!isFixedHeaderShowing && posTop < scrollPosY) {
            isFixedHeaderShowing = true
            addStaticHeader(divId)
        } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
            $(`#${divId} table thead`).removeClass('fixed-header')
            isFixedHeaderShowing = false
        }
    }

    function addStaticHeader(divId) {
        const width = $(`#${divId}`).outerWidth()
        // $(".tr-component-row th").removeClass("column-sort");

        if (width && width > 767) {
            // console.log(width);
            let tableCell = 0

            // Set TH Width before applying fixed-header
            $('.default-table-row')
                .first()
                .children('td')
                .each(function handleEach() {
                    const rowWidth = $(this).outerWidth()
                    $(`.tr-component-row th:nth-child(${tableCell + 1})`).css(
                        'width',
                        rowWidth
                    )
                    tableCell++
                })

            $(`#${divId} table thead`).addClass('fixed-header')
            tableCell = 0

            // Set TD Width before applying fixed-header
            $('.tr-component-row')
                .children('th')
                .each(function cssAdder() {
                    const rowWidth = $(this).outerWidth()
                    $(`.default-table-row td:nth-child(${tableCell + 1})`).css(
                        'width',
                        rowWidth
                    )
                    tableCell++
                })
        }
    }

    window.addEventListener('resize', () => {
        if (isFixedHeaderShowing) {
            addStaticHeader(tableDivId)
        }
    })

    function populateUrl() {
        const url = `${getUrl()}&sort=${$('#sort').val()}&sortDir=${$(
            '#sortDir'
        ).val()}`
        window.history.pushState('', '', url)
        return url
    }

    createChart()
})

function createChart() {
    let chartWidth = $('#chart').width()

    if (chartWidth > 1060) {
        chartWidth = 1060
    }

    /// Get Unique positions
    const positionsGroupBy = _.groupBy(
        data,
        (d) => d.batter_started_at_position
    )

    const positions = []
    // eslint-disable-next-line
    for (const pos in positionsGroupBy) {
        positions.push(Number(pos))
    }

    if (positions.length === 1) {
        height = 150
    } else {
        height = 500
    }

    const toolTipEl = d3
        .select(window.document.body)
        .append('div')
        .attr('class', 'tooltip')
        .style('id', 'tooltip')
        .style('opacity', 0)
        .style('posiition', 'absolute')
        .style('position', 'absolute')
        .style('padding', '6px')
        .style('font', '12px sans-serif')
        .style('background', '#ffffff')
        .style('line-height', 1.8)
        .style('border', 'solid 1px #000')
        .style('border-radius', '8px')
        .style('pointer-events', 'none')

    // set the dimensions and margins of the graph
    const margin = { top: 60, right: 20, bottom: 30, left: 50 }
    const width = chartWidth - margin.left - margin.right
    // eslint-disable-next-line
    var height = height - margin.top - margin.bottom

    const scaleTitleFontSize = d3
        .scaleLinear()
        .domain([150, 1060])
        .range([12, 18])

    const scaleAxisFontSize = d3
        .scaleLinear()
        .domain([150, 1060])
        .range([8, 14])

    const scaleRadius = d3.scaleLinear().domain([150, 1060]).range([3, 8])

    const x = d3.scaleLinear().range([0, width])
    const y = d3.scaleLinear().range([height, 0])

    const svg = d3
        .select('#chart')
        .append('svg')
        .attr('id', 'scatter')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)

    svg.append('rect')
        .attr('height', '100%')
        .attr('width', '100%')
        .attr('fill', '#ffffff')

    const title = svg.append('g').attr('id', 'title')

    let team = ''
    if ($('#ddlTeamId').val()) {
        team = ` - ${$('#ddlTeamId option:selected').text()}`
    }

    const minSeason = document.getElementById('ddlStartSeason').value
    const maxSeason = document.getElementById('ddlEndSeason').value

    let years = ''
    if (minSeason === maxSeason) {
        years = minSeason
    } else {
        years = `${minSeason} - ${maxSeason}`
    }
    title
        .append('text')
        .attr('transform', `translate(${width / 2.8}, 30)`)
        .style('font-family', 'Roboto Condensed')
        .style('font-size', scaleTitleFontSize(width))
        .text(`${years} Baserunning Sprint Speed, By Position${team}`)

    const scatter = svg
        .append('g')
        .attr('transform', `translate(${margin.left},${margin.top})`)

    /* svg.append('defs')
          .append('style')
          .attr('type', 'text/css')
          .text("@import url('https://fonts.googleapis.com/css?family=Roboto+Condensed');"); */

    const slowest = d3.min(data, (d) =>
        Number(d.r_sprint_speed_top50percent_pretty)
    )

    // Scale the range of the data
    x.domain([Math.min(21, Math.floor(slowest)), 31])

    const yMax = _.max(positions)
    const yMin = _.min(positions)
    y.domain([yMax + 0.5, yMin - 0.5])

    scatter
        .append('g')
        .attr('class', 'xaxis')
        .attr('transform', `translate(0,${height})`)
        .call(
            d3
                .axisBottom(x)
                .tickPadding(10)
                .tickFormat((d) => `${d} ft/s`)
        )

    // Add the Y Axis
    scatter
        .append('g')
        .attr('class', 'yaxis')
        .call(
            d3
                .axisLeft(y)
                .tickPadding(10)
                .ticks(positions.length)
                .tickFormat((d) => getPosition(d))
        )

    scatter
        .selectAll('.xaxis text')
        .style('text-anchor', 'middle')
        .style('font-family', 'Roboto Condensed')
        .style('font-size', scaleAxisFontSize(width))

    scatter
        .selectAll('.yaxis text')
        .style('text-anchor', 'end')
        .style('font-family', 'Roboto Condensed')
        .style('font-size', scaleAxisFontSize(width))
        .attr('dx', '-.8em')
        .attr('dy', '.15em')

    // Set line height to 2.5 is only one position player selected
    let y2 = positions.length + 1.5
    let y1 = 1.5
    if (positions.length === 1) {
        y2 = yMin - 0.5
        y1 = yMax + 0.5
    }

    scatter
        .append('line')
        .attr('x1', x(27))
        .attr('y1', y(y1))
        .attr('x2', x(27))
        .attr('y2', y(y2))
        .style('stroke', '#ff0000')
        .style('stroke-dasharray', '5,5')

    scatter
        .append('text')
        .attr('x', x(26.75))
        .attr('y', y(yMin - 0.6))
        .style('font-family', 'Roboto Condensed')
        .style('fill', '#ff0000')
        .style('font-size', scaleAxisFontSize(width))
        .text('League Avg.')

    // Add the scatterplot
    scatter
        .selectAll('dot')
        .data(data)
        .enter()
        .append('circle')
        .attr('r', scaleRadius(width))
        .attr('cx', (d) => x(Number(d.r_sprint_speed_top50percent)))
        .attr('cy', (d) => y(Number(d.batter_started_at_position)))
        .style('fill', (d) => {
            if (query_string.team) {
                return '#c2c2c2'
            }
            return colorScaleNumbers(d.batter_started_at_position)
        })
        .attr('opacity', () => {
            if (query_string.team) {
                return 0.3
            }
            return 1
        })
        .style('stroke-opacity', () => {
            if (query_string.team) {
                return 0.3
            }
            return 1
        })
        .style('stroke', '#000000')
        .on('mouseover', (event, d) => {
            toolTipEl.style('opacity', 0.9)

            toolTipEl
                .html(
                    `${d.name_display_last_first} - ${Number(
                        d.r_sprint_speed_top50percent
                    ).toFixed(1)} ft/s`
                )
                .style('left', `${event.pageX + 10}px`)
                .style('top', `${event.pageY - 10}px`)
        })
        .on('mouseout', () => {
            toolTipEl.style('opacity', 0)
        })

    if (query_string.team) {
        const teamData = _.filter(
            data,
            (d) => d.team_id === Number(query_string.team)
        )

        scatter
            .selectAll('teamDot')
            .data(teamData)
            .enter()
            .append('circle')
            .attr('r', scaleRadius(width))
            .attr('cx', (d) => x(Number(d.r_sprint_speed_top50percent)))
            .attr('cy', (d) => y(Number(d.batter_started_at_position)))
            .style('fill', (d) =>
                colorScaleNumbers(d.batter_started_at_position)
            )
            .style('stroke', '#000000')
            .on('mouseover', (event, d) => {
                toolTipEl.style('opacity', 0.9)

                toolTipEl
                    .html(
                        `${d.name_display_last_first} - ${Number(
                            d.r_sprint_speed_top50percent
                        ).toFixed(1)} ft/s`
                    )
                    .style('left', `${event.pageX + 10}px`)
                    .style('top', `${event.pageY - 10}px`)
            })
            .on('mouseout', () => {
                toolTipEl.style('opacity', 0)
            })
    }

    // Add the X Axis

    function getPosition(pos) {
        if (Number(pos) === 1) {
            return 'P'
        }
        if (Number(pos) === 2) {
            return 'C'
        }
        if (Number(pos) === 3) {
            return '1B'
        }
        if (Number(pos) === 4) {
            return '2B'
        }
        if (Number(pos) === 5) {
            return '3B'
        }
        if (Number(pos) === 6) {
            return 'SS'
        }
        if (Number(pos) === 7) {
            return 'LF'
        }
        if (Number(pos) === 8) {
            return 'CF'
        }
        if (Number(pos) === 9) {
            return 'RF'
        }
        if (Number(pos) === 10) {
            return 'DH'
        }

        return 'PH'
    }
}
